class BundleBuilder extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;
    this.formId = this.dataset.formId;
    this.bundleDiscountName = this.dataset.bundleDiscountName;
    this.bundleSize = this.dataset.bundleSize;
    this.parentId = this.querySelector(".bundle-variant-options")?.dataset.parentId || null;
    this.parentTitle = this.dataset.parentTitle;
    this.bundleDiscountValue = this.dataset.bundleDiscountValue || 0;
    this.currencySymbol = this.dataset.currencySymbol || "";
    this.url = this.dataset.url;
    this.randomNumber = Math.random().toString(36).substring(2, 15);
    this.bundleId = `custom-bundle-${this.randomNumber}`;

    this.variantPickerAccordion = this.querySelector("#collapsible-content-select-bed-size");
    this.variantPickerAccordionSelectedTitle = this.querySelector("#collapsible-content-select-bed-size .currently-selected-variant-title");

    this.PDPBuyButton = this.closest("product-info")?.querySelector("product-form button[type='submit']");
    this.StickyATC = document.querySelector("sticky-atc .sticky-atc-button__submit");
  }

  connectedCallback() {
    this.setInitialState();
    this.targetElements();
    this.attachListeners();
    this.updateBuyButtonState();
  }

  updateBuyButtonState() {
    if (this.state.baseLayer && this.state.duvet && this.state.pillow) {
      if (this.PDPBuyButton) {
        this.PDPBuyButton.removeAttribute("aria-disabled");
        this.PDPBuyButton.removeAttribute("aria-label");
        this.PDPBuyButton.classList.remove("disabled");
      }
      if (this.StickyATC) {
        this.StickyATC.removeAttribute("aria-disabled");
        this.StickyATC.removeAttribute("aria-label");
        this.StickyATC.classList.remove("disabled");
      }
    } else {
      if (this.PDPBuyButton) {
        this.PDPBuyButton.setAttribute("aria-disabled", "true");
        this.PDPBuyButton.setAttribute("aria-label", "Select your bundle");
        this.PDPBuyButton.classList.add("disabled");
      }
      if (this.StickyATC) {
        this.StickyATC.setAttribute("aria-disabled", "true");
        this.StickyATC.setAttribute("aria-label", "Select your bundle");
        this.StickyATC.classList.add("disabled");
      }
    }
  }

  updatePrice() {
    let finalPrice = 0;
    let originalPrice = 0;
    let totalSave = 0;

    if (this.state.baseLayer || this.state.duvet || this.state.pillow || this.state.pillow_optional) {
      this.PdpFromCopy.forEach((element) => element.remove());
    }

    const items = [this.state.baseLayer, this.state.duvet, this.state.pillow, this.state.pillow_optional].filter(Boolean);

    items.forEach((item) => {
      // convert cents -> normal price
      const itemPrice = parseFloat(item.compareAtPriceRaw) / 100;

      originalPrice += itemPrice;

      if (this.bundleDiscountValue > 0) {
        // discount per item, rounded to 2 decimals
        const discounted = +(itemPrice * (1 - this.bundleDiscountValue)).toFixed(2);

        finalPrice += discounted;
        totalSave += +(itemPrice - discounted).toFixed(2);
      } else {
        finalPrice += itemPrice;
      }
    });

    // Format output
    const formattedFinal = `${this.currencySymbol}${finalPrice.toFixed(2)}`;
    const formattedOriginal = `${this.currencySymbol}${originalPrice.toFixed(2)}`;
    const formattedSave = `Save ${this.currencySymbol}${totalSave.toFixed(2)}`;

    if (this.PdpFinalPrice.length > 0) {
      this.PdpFinalPrice.forEach((element) => {
        element.innerHTML = formattedFinal;
      });
    }

    if (this.PdpPrice.length > 0) {
      this.PdpPrice.forEach((element) => {
        element.innerHTML = formattedOriginal;
      });
    }

    if (this.bundleSaveAmount.length > 0) {
      this.bundleSaveAmount.forEach((element) => {
        element.innerHTML = formattedSave;
      });
    }
  }

  setInitialState() {
    this.state = {
      customBundleSize: this.variantPickerAccordionSelectedTitle.innerHTML,
      baseLayer: null,
      duvet: null,
      pillow: null,
      pillow_optional: null,
    };
  }

  targetElements() {
    // Custom Bundle: Variant Inputs
    this.variantInputsContainer = this.querySelector(".variant-inputs");
    // Custom Bundle: Variants
    this.customBundleVariants = this.querySelectorAll("#custom-bundle-variants .bundle-size-card");
    this.customBundleVariants.forEach((variant) => {
      variant.addEventListener("click", this.onVariantChange.bind(this));
    });
    // Custom Bundle: Base Layers
    this.baseLayerVariants = this.querySelectorAll("#bundle-builder--base-layers .bundle-variant-card button");
    this.baseLayerSelectedTitle = this.querySelector("#bundle-builder--base-layers .currently-selected-variant-title");
    this.baseLayerSelectedPrice = this.querySelector("#bundle-builder--base-layers .currently-selected-variant-price");
    this.baseLayerSelectedCompareAtPrice = this.querySelector("#bundle-builder--base-layers .currently-selected-variant-price--compare-at");
    // Custom Bundle: Duvets
    this.duvetVariants = this.querySelectorAll("#bundle-builder--duvets .bundle-variant-card");
    // Custom Bundle: Pillows
    this.pillowVariants = this.querySelectorAll("#bundle-builder--pillows .bundle-variant-card");
    // Custom Bundle: Optional Pillows
    this.pillowOptionalVariants = this.querySelectorAll("#bundle-builder--pillow-optional .bundle-variant-card button");

    // Custom Bundle: Duvets
    this.duvetSizes = this.querySelectorAll("#bundle-builder--duvets .duvet-sizes .duvet-size-card");
    this.duvetSizeSelectedSize = this.querySelector("#bundle-builder--duvets .currently-selected-duvet-size");
    this.duvetVariants = this.querySelectorAll("#bundle-builder--duvets .duvet-variants .bundle-variant-card");
    this.duvetSelectedTitle = this.querySelectorAll("#bundle-builder--duvets .currently-selected-variant-title");
    this.duvetSelectedPrice = this.querySelectorAll("#bundle-builder--duvets .currently-selected-variant-price");
    this.duvetSelectedCompareAtPrice = this.querySelectorAll("#bundle-builder--duvets .currently-selected-variant-price--compare-at");

    // Custom Bundle: Pillow
    this.pillowSizes = this.querySelectorAll("#bundle-builder--pillows .pillow-sizes .pillow-size-card");
    this.pillowSizeSelectedSize = this.querySelector("#bundle-builder--pillows .currently-selected-pillow-size");
    this.pillowVariants = this.querySelectorAll("#bundle-builder--pillows .pillow-variants .bundle-variant-card");
    this.pillowSelectedTitle = this.querySelectorAll("#bundle-builder--pillows .currently-selected-variant-title");
    this.pillowSelectedPrice = this.querySelectorAll("#bundle-builder--pillows .currently-selected-variant-price");
    this.pillowSelectedCompareAtPrice = this.querySelectorAll("#bundle-builder--pillows .currently-selected-variant-price--compare-at");

    // Custom Bundle: Pillow Optional
    this.pillowOptionalSizes = this.querySelectorAll("#bundle-builder--pillows-optional .pillow-sizes .pillow-size-card");
    this.pillowOptionalSizeSelectedSize = this.querySelector("#bundle-builder--pillows-optional .currently-selected-pillow-size");
    this.pillowOptionalVariants = this.querySelectorAll("#bundle-builder--pillows-optional .pillow-variants .bundle-variant-card");
    this.pillowOptionalSelectedTitle = this.querySelectorAll("#bundle-builder--pillows-optional .currently-selected-variant-title");
    this.pillowOptionalSelectedPrice = this.querySelectorAll("#bundle-builder--pillows-optional .currently-selected-variant-price");
    this.pillowOptionalSelectedCompareAtPrice = this.querySelectorAll("#bundle-builder--pillows-optional .currently-selected-variant-price--compare-at");

    // Custom Bundle: Summary Box
    this.summaryBoxBaseLayer = this.querySelector(".bundle-builder-summary-box .base-layer-summary");
    this.summaryBoxDuvet = this.querySelector(".bundle-builder-summary-box .duvet-summary");
    this.summaryBoxPillow = this.querySelector(".bundle-builder-summary-box .pillow-summary");
    this.summaryBoxPillowOptional = this.querySelector(".bundle-builder-summary-box .pillow-optional-summary");

    // Custom Bundle: PDP Price
    // this.PdpPriceElement = document.querySelector("#pdp-custom-bundle-price");
    this.PdpFromCopy = document?.querySelectorAll(".bundle-price-from");
    this.PdpFinalPrice = document?.querySelectorAll(".bundle-final-price");
    this.PdpPrice = document?.querySelectorAll(".bundle-price");
    this.bundleSaveAmount = document?.querySelectorAll(".bundle-save-amount");
  }

  attachListeners() {
    // Base Layer Variants
    this.baseLayerVariants.forEach((variant) => {
      variant.addEventListener("click", this.baseLayerVariantSelect.bind(this));
    });

    // Duvet Sizes
    this.duvetSizes.forEach((size) => {
      size.addEventListener("click", this.duvetVariantSizeSelect.bind(this));
    });

    // Duvet Variants
    this.duvetVariants.forEach((variant) => {
      variant.addEventListener("click", this.duvetVariantSelect.bind(this));
    });

    // Pillow Sizes
    this.pillowSizes.forEach((size) => {
      size.addEventListener("click", this.pillowVariantSizeSelect.bind(this));
    });
    // Pillow Variants
    this.pillowVariants.forEach((variant) => {
      variant.addEventListener("click", this.pillowVariantSelect.bind(this));
    });

    // Pillow Optional Sizes
    if (this.pillowOptionalSizes) {
      this.pillowOptionalSizes.forEach((size) => {
        size.addEventListener("click", this.pillowOptionalVariantSizeSelect.bind(this));
      });
    }

    // Pillow Optional Variants
    if (this.pillowOptionalVariants) {
      this.pillowOptionalVariants.forEach((variant) => {
        variant.addEventListener("click", this.pillowOptionalVariantSelect.bind(this));
      });
    }
  }

  baseLayerVariantSelect(event) {
    const element = event.target.closest(".bundle-variant-card");

    if (!element) return;

    this.state.baseLayer = {
      id: element.dataset.id,
      options: element.dataset.options,
      title: element.dataset.title,
      priceRaw: element.dataset.priceRaw,
      linePrice: element.dataset.linePrice,
      price: element.dataset.price,
      compareAtPriceRaw: element.dataset.compareAtPriceRaw,
      compareAtPrice: element.dataset.compareAtPrice,
    };

    event.currentTarget.classList.add("selected");
    this.baseLayerVariants.forEach((v) => {
      if (v !== event.currentTarget) {
        v.classList.remove("selected");
      }
    });

    this.baseLayerSelectedTitle.innerHTML = this.state.baseLayer.title;
    this.baseLayerSelectedPrice.innerHTML = this.state.baseLayer.price;
    this.baseLayerSelectedCompareAtPrice.innerHTML = this.state.baseLayer.compareAtPrice;

    const closestAccordion = element.closest("collapsible-content");
    if (closestAccordion) {
      closestAccordion.close();
      const nextAccordion = closestAccordion.nextElementSibling;
      if (nextAccordion && nextAccordion.tagName.toLowerCase() === "collapsible-content") {
        nextAccordion.open();
      }
    }

    this.createInputs();
    this.updateSummaryBox();
    this.updatePrice();
    this.updateBuyButtonState();
  }

  duvetVariantSizeSelect(event) {
    const element = event.currentTarget;

    if (!element) return;

    element.classList.add("selected");
    this.duvetSizes.forEach((size) => {
      if (size !== element) {
        size.classList.remove("selected");
      }
    });

    this.duvetSelectedTitle.forEach((title) => {
      title.innerHTML = "";
    });
    this.duvetSelectedPrice.forEach((price) => {
      price.innerHTML = "";
    });
    this.duvetSelectedCompareAtPrice.forEach((compareAtPrice) => {
      compareAtPrice.innerHTML = "";
    });

    this.duvetSizeSelectedSize.textContent = element.dataset.sizeValueVisual;

    this.filterDuvetVariantsBySize(element.dataset.sizeValue);

    const closestAccordion = element.closest("collapsible-content");
    if (closestAccordion) {
      closestAccordion.close();
      const nextAccordion = closestAccordion.nextElementSibling;
      if (nextAccordion && nextAccordion.tagName.toLowerCase() === "collapsible-content") {
        nextAccordion.open();
        nextAccordion.classList.remove("hidden");
      }
    }
  }

  filterDuvetVariantsBySize(size) {
    this.state.duvet = null;
    if (this.state.pillow || this.state.duvet || this.state.baseLayer || this.state.pillow_optional) {
      this.updateBuyButtonState();
      this.updateSummaryBox();
      this.updatePrice();
    }
    this.duvetVariants.forEach((variant) => {
      variant.querySelector("button").classList.remove("selected");
      variant.classList.remove("hidden");
    });
    this.duvetVariants.forEach((variant) => {
      const options = variant.dataset.options.toLowerCase();
      const regex = new RegExp(`\\b${size.toLowerCase()}\\b`);

      if (!regex.test(options)) {
        variant.classList.add("hidden");
      }
    });
  }

  duvetVariantSelect(event) {
    const element = event.currentTarget;
    if (!element) return;

    this.state.duvet = {
      id: element.dataset.id,
      options: element.dataset.options,
      title: element.dataset.title,
      priceRaw: element.dataset.priceRaw,
      linePrice: element.dataset.linePrice,
      price: element.dataset.price,
      compareAtPriceRaw: element.dataset.compareAtPriceRaw,
      compareAtPrice: element.dataset.compareAtPrice,
    };

    element.querySelector("button").classList.add("selected");
    this.duvetVariants.forEach((v) => {
      if (v !== element) {
        v.querySelector("button").classList.remove("selected");
      }
    });

    this.duvetSelectedTitle.forEach((title) => {
      title.innerHTML = this.state.duvet.title;
    });
    this.duvetSelectedPrice.forEach((price) => {
      price.innerHTML = this.state.duvet.price;
    });
    this.duvetSelectedCompareAtPrice.forEach((compareAtPrice) => {
      compareAtPrice.innerHTML = this.state.duvet.compareAtPrice;
    });
    // Close the current accordion and open the next one
    const closestAccordion = element.closest("collapsible-content");
    if (closestAccordion) {
      closestAccordion.close();

      const nextClosestAccordion = this.querySelector("#bundle-builder--duvets");
      if (nextClosestAccordion) {
        nextClosestAccordion.close();
      }

      const nextAccordion = nextClosestAccordion?.nextElementSibling;
      if (nextAccordion && nextAccordion.tagName.toLowerCase() === "collapsible-content") {
        nextAccordion.open();
        nextAccordion.classList.remove("hidden");
      }
    }

    this.createInputs();
    this.updateSummaryBox();
    this.updatePrice();
    this.updateBuyButtonState();
  }

  pillowVariantSizeSelect(event) {
    const element = event.currentTarget;
    if (!element) return;
    element.classList.add("selected");
    this.pillowSizes.forEach((size) => {
      if (size !== element) {
        size.classList.remove("selected");
      }
    });
    this.pillowSelectedTitle.forEach((title) => {
      title.innerHTML = "";
    });
    this.pillowSelectedPrice.forEach((price) => {
      price.innerHTML = "";
    });
    this.pillowSelectedCompareAtPrice.forEach((compareAtPrice) => {
      compareAtPrice.innerHTML = "";
    });
    this.pillowSizeSelectedSize.textContent = element.dataset.sizeValueVisual;
    this.filterPillowVariantsBySize(element.dataset.sizeValue);
    const closestAccordion = element.closest("collapsible-content");
    if (closestAccordion) {
      closestAccordion.close();
      const nextAccordion = closestAccordion.nextElementSibling;
      if (nextAccordion && nextAccordion.tagName.toLowerCase() === "collapsible-content") {
        nextAccordion.open();
        nextAccordion.classList.remove("hidden");
      }
    }
  }
  filterPillowVariantsBySize(size) {
    this.state.pillow = null;
    if (this.state.pillow || this.state.duvet || this.state.baseLayer || this.state.pillow_optional) {
      this.updateBuyButtonState();
      this.updateSummaryBox();
      this.updatePrice();
    }
    this.pillowVariants.forEach((variant) => {
      variant.querySelector("button").classList.remove("selected");
      variant.classList.remove("hidden");
      if (!variant.dataset.options.includes(size)) {
        variant.classList.add("hidden");
      } else {
        variant.classList.remove("hidden");
      }
    });
  }
  pillowVariantSelect(event) {
    const element = event.currentTarget;
    if (!element) return;
    this.state.pillow = {
      id: element.dataset.id,
      options: element.dataset.options,
      title: element.dataset.title,
      priceRaw: element.dataset.priceRaw,
      linePrice: element.dataset.linePrice,
      price: element.dataset.price,
      compareAtPriceRaw: element.dataset.compareAtPriceRaw,
      compareAtPrice: element.dataset.compareAtPrice,
    };
    element.querySelector("button").classList.add("selected");
    this.pillowVariants.forEach((v) => {
      if (v !== element) {
        v.querySelector("button").classList.remove("selected");
      }
    });
    this.pillowSelectedTitle.forEach((title) => {
      title.innerHTML = this.state.pillow.title;
    });
    this.pillowSelectedPrice.forEach((price) => {
      price.innerHTML = this.state.pillow.price;
    });
    this.pillowSelectedCompareAtPrice.forEach((compareAtPrice) => {
      compareAtPrice.innerHTML = this.state.pillow.compareAtPrice;
    });
    // Close the current accordion and open the next one
    const closestAccordion = element.closest("collapsible-content");
    if (closestAccordion) {
      closestAccordion.close();
      const nextClosestAccordion = this.querySelector("#bundle-builder--pillows");
      if (nextClosestAccordion) {
        nextClosestAccordion.close();
      }
      const nextAccordion = nextClosestAccordion?.nextElementSibling;
      if (nextAccordion && nextAccordion.tagName.toLowerCase() === "collapsible-content") {
        nextAccordion.open();
        nextAccordion.classList.remove("hidden");
      }
    }

    this.createInputs();
    this.updateSummaryBox();
    this.updatePrice();
    this.updateBuyButtonState();
  }

  pillowOptionalVariantSizeSelect(event) {
    const element = event.currentTarget;
    if (!element) return;
    element.classList.add("selected");
    this.pillowOptionalSizes.forEach((size) => {
      if (size !== element) {
        size.classList.remove("selected");
      }
    });
    this.pillowOptionalSelectedTitle.forEach((title) => {
      title.innerHTML = "";
    });
    this.pillowOptionalSelectedPrice.forEach((price) => {
      price.innerHTML = "";
    });
    this.pillowOptionalSelectedCompareAtPrice.forEach((compareAtPrice) => {
      compareAtPrice.innerHTML = "";
    });
    this.pillowOptionalSizeSelectedSize.textContent = element.dataset.sizeValueVisual;
    this.filterPillowOptionalVariantsBySize(element.dataset.sizeValue);
    const closestAccordion = element.closest("collapsible-content");
    if (closestAccordion) {
      closestAccordion.close();
      const nextAccordion = closestAccordion.nextElementSibling;
      if (nextAccordion && nextAccordion.tagName.toLowerCase() === "collapsible-content") {
        nextAccordion.open();
        nextAccordion.classList.remove("hidden");
      }
    }
  }
  filterPillowOptionalVariantsBySize(size) {
    this.state.pillow_optional = null;
    if (this.state.pillow || this.state.duvet || this.state.baseLayer || this.state.pillow_optional) {
      this.updateBuyButtonState();
      this.updateSummaryBox();
      this.updatePrice();
    }
    this.pillowOptionalVariants.forEach((variant) => {
      variant.querySelector("button").classList.remove("selected");
      variant.classList.remove("hidden");
      if (!variant.dataset.options.includes(size)) {
        variant.classList.add("hidden");
      } else {
        variant.classList.remove("hidden");
      }
    });
  }
  pillowOptionalVariantSelect(event) {
    const element = event.currentTarget;
    if (!element) return;
    this.state.pillow_optional = {
      id: element.dataset.id,
      options: element.dataset.options,
      title: element.dataset.title,
      priceRaw: element.dataset.priceRaw,
      linePrice: element.dataset.linePrice,
      price: element.dataset.price,
      compareAtPriceRaw: element.dataset.compareAtPriceRaw,
      compareAtPrice: element.dataset.compareAtPrice,
    };
    element.querySelector("button").classList.add("selected");
    this.pillowOptionalVariants.forEach((v) => {
      if (v !== element) {
        v.querySelector("button").classList.remove("selected");
      }
    });
    this.pillowOptionalSelectedTitle.forEach((title) => {
      title.innerHTML = this.state.pillow_optional.title;
    });
    this.pillowOptionalSelectedPrice.forEach((price) => {
      price.innerHTML = this.state.pillow_optional.price;
    });
    this.pillowOptionalSelectedCompareAtPrice.forEach((compareAtPrice) => {
      compareAtPrice.innerHTML = this.state.pillow_optional.compareAtPrice;
    });
    // Close the current accordion and open the next one
    const closestAccordion = element.closest("collapsible-content");
    if (closestAccordion) {
      closestAccordion.close();
      const nextClosestAccordion = this.querySelector("#bundle-builder--pillows-optional");
      if (nextClosestAccordion) {
        nextClosestAccordion.close();
      }
      const nextAccordion = nextClosestAccordion?.nextElementSibling;
      if (nextAccordion && nextAccordion.tagName.toLowerCase() === "collapsible-content") {
        nextAccordion.open();
        nextAccordion.classList.remove("hidden");
      }
    }
    this.createInputs();
    this.updateSummaryBox();
    this.updatePrice();
    this.updateBuyButtonState();
  }

  onVariantChange(event) {
    // Get element
    const variant = event.currentTarget;

    // If the clicked element is not a variant card, find the closest one
    if (variant.classList.contains("selected")) {
      this.variantPickerAccordion.close();
      this.querySelector("#bundle-builder--base-layers").open();
      return;
    }

    // Remove selected class from all variants and add to the clicked one
    this.customBundleVariants.forEach((v) => {
      v.classList.remove("selected");
    });
    variant.classList.add("selected");

    // fetch the new variant options based on the selected variant
    const variantId = variant.dataset.variantId;
    fetch(`${this.url}?variant=${variantId}&section_id=${this.sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        // Parse the response text as HTML
        const html = new DOMParser().parseFromString(responseText, "text/html");

        // Update frontend
        const bundleBuilderOptions = html.querySelector("bundle-builder .bundle-variant-options");
        const targetBundleBuilderOptions = document.querySelector("bundle-builder .bundle-variant-options");

        const PdpCustomBundlePrice = html.querySelector("#pdp-custom-bundle-price");
        const targetPdpCustomBundlePrice = document.querySelector("#pdp-custom-bundle-price");

        if (bundleBuilderOptions && targetBundleBuilderOptions) {
          targetBundleBuilderOptions.innerHTML = bundleBuilderOptions.innerHTML;
        }

        if (PdpCustomBundlePrice && targetPdpCustomBundlePrice) {
          targetPdpCustomBundlePrice.innerHTML = PdpCustomBundlePrice.innerHTML;
        }

        const buyButton = document.querySelector("product-info product-form input[name='id']");
        if (buyButton) {
          buyButton.value = variant.dataset.variantId;
        }
        this.setInitialState();
        this.targetElements();
        this.attachListeners();
        this.updateBuyButtonState();

        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("variant", variant.dataset.variantId);
        window.history.pushState({}, "", currentUrl.toString());

        // Update the variant picker accordion title
        this.variantPickerAccordionSelectedTitle.innerHTML = variant.dataset.variantValue;
        this.state.customBundleSize = variant.dataset.variantValue;

        this.variantPickerAccordion.close();
        this.querySelector("#bundle-builder--base-layers").open();
      });
  }

  createStateInputs(index, stateObject) {
    const formId = this.formId;
    this.randomNumber = Math.random().toString(36).substring(2, 15);

    // Collect all selected items in the bundle
    const selectedItems = [this.state.baseLayer, this.state.duvet, this.state.pillow, this.state.pillow_optional].filter(Boolean); // remove nulls

    // Map to only id and price
    const bundlePartsArray = selectedItems.map((item) => ({
      id: item.id,
      price: item.linePrice || item.priceRaw,
    }));

    // Convert to JSON and escape quotes for HTML
    const bundlePartsEscaped = JSON.stringify(bundlePartsArray).replace(/"/g, "&quot;");

    return `
      <input
        class="bundle--input"
        id="fixed-bundle-id-${this.randomNumber}"
        type="hidden"
        name="[properties][_woolroomBundleID]"
        value="${this.bundleId}"
        form="${formId}"
      >
      <input
        class="bundle--input"
        id="fixed-bundle-parts-${this.randomNumber}"
        type="hidden"
        name="[properties][_bundleParts]"
        value='${bundlePartsEscaped}'
        form="${formId}"
      >
      <input
        class="bundle--input"
        id="fixed-bundle-discount-${this.randomNumber}"
        type="hidden"
        name="[properties][_bundleDiscountName]"
        value="${this.bundleDiscountName || ""}"
        form="${formId}"
      >
    `;
  }

  createInputs() {
    // for eeach state key, create an input element with the state value
    this.parentId = this.querySelector(".bundle-variant-options")?.dataset.parentId || null;
    this.bundleId = `custom-bundle-${this.randomNumber}`;
    if (this.state.pillow_optional != null) this.bundleSize = 4;
    else {
      this.bundleSize = 3;
    }
    let inputs = "";
    let index = 0;
    if (this.state.baseLayer) {
      inputs = this.createStateInputs(index++, this.state.baseLayer);
    }
    if (this.state.duvet) {
      inputs = this.createStateInputs(index++, this.state.duvet);
    }
    if (this.state.pillow) {
      inputs = this.createStateInputs(index++, this.state.pillow);
    }
    if (this.state.pillow_optional) {
      inputs = this.createStateInputs(index++, this.state.pillow_optional);
    }

    this.variantInputsContainer.innerHTML = inputs;
  }

  updateSummaryBox() {
    if (this.state.baseLayer != null) {
      this.summaryBoxBaseLayer.querySelector("span:last-child").textContent = this.state.baseLayer.title;
      this.summaryBoxBaseLayer.classList.remove("hidden");
    }
    if (this.state.duvet != null) {
      this.summaryBoxDuvet.querySelector("span:last-child").textContent = this.state.duvet.title;
      this.summaryBoxDuvet.classList.remove("hidden");
    }
    if (this.state.pillow != null) {
      this.summaryBoxPillow.querySelector("span:last-child").textContent = this.state.pillow.title;
      this.summaryBoxPillow.classList.remove("hidden");
    }
    if (this.state.pillow_optional != null) {
      this.summaryBoxPillowOptional.querySelector("span:last-child").textContent = this.state.pillow_optional.title;
      this.summaryBoxPillowOptional.classList.remove("hidden");
    }
  }
}

customElements.define("bundle-builder", BundleBuilder);
